import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function BottomNav({ userData }) {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;

    const tabs = [
        { key: '/', icon: '📅', label: 'Хуваарь' },
        { key: '/requests', icon: '📋', label: 'Хүсэлт' },
        { key: '/create', icon: '➕', label: 'Нэмэх', isCenter: true },
        { key: '/profile', icon: '👤', label: 'Профайл' },
    ];

    if (path === '/login' || path === '/pending') return null;

    return (
        <nav className="bottom-nav">
            {tabs.map(tab => {
                const isActive = tab.key === '/'
                    ? path === '/'
                    : path.startsWith(tab.key);
                return (
                    <button
                        key={tab.key}
                        className={`bottom-nav__tab${isActive ? ' bottom-nav__tab--active' : ''}${tab.isCenter ? ' bottom-nav__tab--center' : ''}`}
                        onClick={() => navigate(tab.key)}
                    >
                        <span className={`bottom-nav__icon${tab.isCenter ? ' bottom-nav__icon--center' : ''}`}>{tab.icon}</span>
                        <span className="bottom-nav__label">{tab.label}</span>
                    </button>
                );
            })}
        </nav>
    );
}

export default BottomNav;
